/* eslint-disable no-console */
import { React, useState, useEffect } from 'react';
import { Grid, GridItem } from '@patternfly/react-core';
import InfoIcon from '@material-ui/icons/Info';
import Dropdown from '../dropdown/dropdown';
import InputRadio from './input_radio';
import PhoneNumber from '../../common/phone_number/phone_number';
import TextFieldComponent from './TextFieldComponent';
import { InputAdornment } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';

import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { formLabelsTheme } from '../../style_jsx/styles';
import { commonNodeModules, commonModules } from '../index';
import bootbox from 'bootbox';

import moment from 'moment';

const useStyles = makeStyles((theme) => ({
        root: {
          display: 'flex',
          flexDirection: 'column',
          flexWrap: 'wrap',
          [theme.breakpoints.down('sm')]: {
            overflow: 'auto',
          },
        },
        input: {
          height: 40,
          padding: 0,
          [theme.breakpoints.up('300')]: {
            width: 130,
          },
          [theme.breakpoints.up('576')]: {
            width: 140,
          },
          [theme.breakpoints.up('768')]: {
            width: 160,
          },
          [theme.breakpoints.up('1024')]: {
            width: 160,
          },
          color: '#76787A',
          fontSize: '14px',
        },
        datepicker: {
          'label + &': {
            marginBottom: 60,
            backgroundColor: 'red',
          },

        },
        checked: {},
      })),

      DatePickerComponent = (props) => {
        const classes = useStyles();
        const { Box } = commonNodeModules;

        let format = 'MM/dd/yyyy';
        let formatDate = props.field ? 'yyyy' : format;
        let views = props.field ? ['year'] : ['year', 'month', 'date'];
        return (
          <Grid item xs={12} className={classes.textFieldGrid}>


            <KeyboardDatePicker
              // minDate={new Date()}
              views={views}
              // placeholder="-"
              maxDate={props.name === 'dob' ? new Date() : ''}
              inputVariant="outlined"
              format={formatDate}
              margin="dense"
              label=""
              value={props.defaultValue}
              onChange={props.handleDateChange}
              className={classes.datepicker}
              InputProps={{
                disableUnderline: true,
                color: '#76787A',
                style: { height: 32 },
                className: `${classes.input}`,
                endAdornment: (
                  <InputAdornment position="end">
                    <Box
                      onClick={() => {}}
                      className="calendarIcon"
                    />
                  </InputAdornment>
                ),
              }}
              // InputAdornmentProps = {{ position: 'right' }}
              // fullWidth
              error={props.error}
              helperText={props.helperText}
            />


          </Grid>//

        );
      };

const InputFormI9 = (props) => {

  const { MuiThemeProvider, Box, isFutureDate } = commonNodeModules;
  const { useTranslateText } = commonModules;
  const { className, fields, titleText, titleSubText, onChange, subTexts } = props,
        { translateText } = useTranslateText(),
        //[phoneError, setPhoneError] = useState(false),
        classNames = `input-form ${className}`;

  const onChangeField = (key, value) => {
    onChange(key, value);
  };


  const [selectedDate, setDate] = useState(moment());
  const [dob, setDOB] = useState(null);
  const [errorDate, setErrorDate] = useState(false),
        [dobError, setDobError] = useState(false);

  useEffect(() => (
    fields && fields.map((item => {
      console.log(item);
      if (item.key === 'effdate') {
        if (item.value === undefined || item.value === '') {
          setDate(moment(new Date()).format('MM/DD/YYYY'));
          onChange('effdate', moment(new Date()).format('MM/DD/YYYY'));

          // setDate(new Date());
          // onChange('effdate', moment(new Date()).format('MM/DD/YYYY'));
        }
        else {
          setDate(item.value);
          onChange('effdate', item.value);
        }


      }
    }))
  ), []);

  const onDateChange = (date, value) => { //effdate
    setDate(date);
    let newVal = '';
    if ((value != null)) {
      if (String(value.includes('_'))) {
        newVal = value.replaceAll('_', '');
      }
      else {
        newVal = value;
      }
      if (newVal.length === 10 && JSON.stringify(date) !== 'null') {
        onChange('effdate', moment(date).format('MM/DD/YYYY'));
      }
      else {
        onChange('effdate', date);
      }
    }
    else {
      setErrorDate(true);
      onChange('effdate', date);
    }
  };

  const onDateOfBirthChange = (date, value) => {
    setDOB(date);
    let newVal = '';
    if ((value != null)) {
      if (String(value.includes('_'))) {
        newVal = value.replaceAll('_', '');
      }
      else {
        newVal = value;
      }
      if (newVal.length === 10 && JSON.stringify(date) !== 'null') {
        onChange('Date_of_Birth', moment(date).format('MM/DD/YYYY')); // "Date_of_Birth"
      }
      else {
        onChange('Date_of_Birth', date);
        setDobError(true);
      }
    }
    else {
      onChange('Date_of_Birth', date);
      setDobError(false);
    }
  };
  const phone_Number_Check = (phone) => {
    if (phone) {
      if (phone.replace(/\D+/g, '').length < 10) {
        // setPhoneError(true);
        return false;
      }
    }
    if (!phone) {
      return false;
    }
    return true;
  };
  const InfoPopUp = (popupData, popupHeader) => {
    bootbox.confirm({
      title: `${translateText(popupHeader)}`,
      message: `${translateText(popupData)}`,
      buttons: {
        cancel: {
          label: translateText('Close'),
          className: 'btn primary_button',
        },
        confirm: {
          label: translateText('OK'),
          className: 'btn primary_button w-unset d-none',
        },
      },
      callback: () => { window.scroll(0, 0) },
    });
  };
  return (
    <MuiThemeProvider theme={formLabelsTheme}>
      <Grid className={classNames}>
        <GridItem lg={12}>
          {titleText &&
          <p className="f20-title pb-3">{translateText(titleText)}
            {titleSubText && <span className="I9-f14-title ml-1">{translateText(titleSubText)}</span>}
            {subTexts}
          </p>
          }
        </GridItem>
        {fields && fields.map((item, i) => {
          const { name, type, value, items, isDisable, key, errorMessage, error, index, isInfo, infoData, isnull, popupHeader, maxlen } = item,
                isText = type === '',
                isNumber = type === 'number',
                isInputText = type === 'text',
                isDropdown = type === 'dropdown',
                isDatepicker = type === 'date',
                isRadio = type === 'radio',
                isPhone = type === 'phone',
                i9form = name === 'Please enter your first day of employment' || type === 'radio' ? 12 : 3,

                itemProps = {
                  selectedItem: value,
                  disabled: isDisable,
                  data: items,
                  stateName: key,
                  value: value,
                  name: key,
                  lable: name,
                  autoComplete: 'off',
                  errorMessage,
                  index,
                  error,
                };

          return (
            <GridItem lg={i9form} key={i} className="pb-3 pr-3">
              <p className="f14-title mb-1"><span>{isInfo && <InfoIcon style={{ cursor: 'pointer' }}
                fontSize="medium" onClick={() => { InfoPopUp(infoData, popupHeader) }} />}
              {translateText(name)}</span></p>
              {isText && <p className="f14-content">{value}</p>}
              {(isInputText || isNumber) && <>
                <TextFieldComponent
                  value={value}
                  name={key}
                  required
                  lable=""
                  autoComplete="off"
                  onChange={(e) => onChangeField(key, e.target.value)}
                  error={error}
                  maxlen={maxlen}
                  helperText={error ?
                    <Box component="span">{translateText(errorMessage)}</Box> : null}
                /></>
              }
              {(isPhone) && <PhoneNumber
                {...{
                  value: value || '',
                  setStateData: onChange,
                  phone_Number_Check,
                  required: false,
                  autoComplete: 'Phone#',
                  name: 'Phone#',
                  nolabel: true,
                  fieldName: 'Phone Number',
                  classes: 'clsphone',
                }
                }
              />}
              {isDatepicker && isnull &&
                <Box className="datePickerContainer"
                  style = {{ height: '08px', marginTop: '-10px' }}>
                  <MuiThemeProvider theme={formLabelsTheme}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <Grid container>
                        <DatePickerComponent
                          className="datePickerEffective"
                          defaultValue={dob}
                          handleDateChange={onDateOfBirthChange}
                          name="dob"
                          error= {isFutureDate(dob) || Boolean((JSON.stringify(dob) === 'null') && dobError) ? true : false}
                          helperText={isFutureDate(dob)
                            ? <Box style={{ 'marginLeft': '-1.5rem' }} component="span">
                              {translateText(`DOB should not be later than Today's Date.`)}</Box>
                            : (JSON.stringify(dob) === 'null') && dobError
                              ? <Box style={{ 'marginLeft': '-1rem' }} component="span">
                                {translateText('Invalid Date')}</Box> : ''}
                        />
                      </Grid>
                    </MuiPickersUtilsProvider>
                  </MuiThemeProvider>
                </Box>

              }
              {isDatepicker && !isnull &&

              // <Box className="datePickerContainer"
              //   style = {{ height: '28px', marginTop: '-10px' }}>
                <MuiThemeProvider theme={formLabelsTheme}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid container>
                      <DatePickerComponent
                        // label={translateText(`Effective Date of W-4`)}
                        className="datePickerEffective"
                        defaultValue={selectedDate}

                        handleDateChange={onDateChange}
                        error= {Boolean(!selectedDate && errorDate) || Boolean(JSON.stringify(selectedDate) === 'null') ? true : false}
                        helperText={(!selectedDate && errorDate) ?
                          <Box style={{ 'marginLeft': '-1rem' }} component="span">
                            {translateText('First day of employment is required.')}</Box> : (JSON.stringify(selectedDate) === 'null')
                            ? <Box style={{ 'marginLeft': '-1rem' }} component="span">
                              {translateText('Invalid Date')}</Box> : ''}
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                </MuiThemeProvider>
                /* </Box> */

              }

              {isDropdown && <Dropdown {...{ ...itemProps, onSelect: value => onChange(key, value) }} />}
              {isRadio && <InputRadio {...{ ...itemProps, onChange: value => onChange(key, value) }} />}
              {/* {isPhone && <PhoneInput {...{ itemProps, onChange: value => onChange(key, value) }} />} */}
            </GridItem>
          );
        })}
      </Grid>
    </MuiThemeProvider>
  );
};

export default InputFormI9;